var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableHead = void 0;
var TableHead_1 = __importDefault(require("./TableHead"));
exports.TableHead = TableHead_1.default;
exports.default = TableHead_1.default;
//# sourceMappingURL=index.js.map